import { useTimeFor } from '@/hooks/useTimeFor';
import type { Appointment } from '@/types/scheduling';
import { Calendar } from 'lucide-react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { RecurringBadge } from '../RecurringBadge/RecurringBadge';
import { SessionItemDropdown } from '../SessionItemDropdown/SessionItemDropdown';

interface SingleSessionListItemProps {
  appointment: Appointment;
}

export const SingleSessionListItem = ({ appointment }: SingleSessionListItemProps) => {
  const { t } = useTranslation('scheduling', { keyPrefix: 'yourSessions' });
  const { format } = useTimeFor('sessionTime');
  const dropdownButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <li key={appointment.appointment_id} className='my-2 flex justify-between py-4 not-last-of-type:border-b'>
      <div className='flex items-center gap-4'>
        <Calendar size={20} aria-hidden className='stroke-text-default-secondary' />
        <div className='flex flex-col gap-1'>
          <h3 className='text-body-m-semibold'>
            <time dateTime={new Date(appointment.appointment_date).toISOString()}>{format(appointment.appointment_date, 'MMMM do, h:mm a')}</time>
          </h3>
          <div className='flex items-center gap-2'>
            <span className='text-text-default-secondary'>
              {t(`deliveryType.${appointment.delivery_type}`)} - {appointment.duration_minutes} {t('minutes')}
            </span>
            {appointment.session_type_enum === 'private' && (
              <>
                <div className='bg-text-default-secondary size-[3px] rounded-full' />
                <span className='text-text-default-secondary'>{t('private')}</span>
              </>
            )}
          </div>
        </div>
      </div>
      <div className='flex items-center gap-2'>
        {appointment.recurring_schedule && <RecurringBadge />}
        <SessionItemDropdown appointment={appointment} openButtonRef={dropdownButtonRef} />
      </div>
    </li>
  );
};
